import PythonApi from '@/services/PythonApi';

export default {
    post(payload) {
        const url = "events";
        return PythonApi().post(url, payload)
    },
    put(id, payload){
        const url = `events/${id}`
        return PythonApi().put(url, payload)
    }
};



// WEBPACK FOOTER //
// ./src/api/events-api.js